import moment from 'moment'
import {webalize} from "webalize";

export const parseQueryString = query => {
  if (!query) {
    return { }
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
   .split('&')
   .reduce((params, param) => {
     const [key, value] = param.split('=')
     params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
     return params
   }, { })
}

export const countUniqueValues = values => {
  const uniqueValues = new Set()
  const counts = {}
  const result = []
  values.forEach((value) => {
    if (uniqueValues.has(value)) counts[values] += 1
    uniqueValues.add(value)
    counts[value] = 1
  })
  uniqueValues.forEach((uniqueValue) => {
    result.push({
      value: uniqueValue,
      count: counts[uniqueValue],
    })
  })
  return result
}

export const metersPerSecondToKilometersPerHour = value => {
  try {
    const parsed = parseFloat(value)
    return Math.round(parsed * 3.6)
  } catch (err) {
    console.error('parseFloat error', err) // eslint-disable-line
    return NaN
  }
}

export const getTimeAfterNMinutes = minutes => {
  const currentDate = moment()
  const afterNMinutes = currentDate.add(minutes, 'm').format()
  return afterNMinutes
}

export const getMinutesTillTime = date => {
  const currentDate = moment()
  const endDate = moment(date)
  const diff = endDate.diff(currentDate, 'minutes')
  return diff + 1
}

export const objectKeysToLowercase = (obj) => {
  return Object.keys(obj).reduce((accumulator, key) => {
    accumulator[key.toLowerCase()] = obj[key];
    return accumulator;
  }, {});
}

export const objectKeysWebalize = (obj) => {
  return Object.keys(obj).reduce((accumulator, key) => {
    accumulator[webalize(key)] = obj[key];
    return accumulator;
  }, {});
}

export const birthDateHumanToDatabase = (date) => {

}

export default {
  parseQueryString,
  countUniqueValues,
  metersPerSecondToKilometersPerHour,
  getTimeAfterNMinutes,
}



// WEBPACK FOOTER //
// ./src/common/lib/utils.js